"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=G4ANoResultPageEvent.js.map